import React from 'react'

export default class Button extends React.Component {
  state = {}
  render() {
    return (
      <button {...this.props}>
        {this.props.label}
      </button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Button.js